import { FormType } from '../enums/form-type.enum'

export type InspectionFormType = FormType.CurbAppeal | FormType.ShowroomInspection

export interface IInspectionWindowItem {
  formType: InspectionFormType
  days: number
}

export interface IInspectionWindowsRequest {
  items: IInspectionWindowItem[]
}

export interface IInspectionWindowsResponse {
  items: IInspectionWindowItem[]
}

// Every field but isOverdue is absent when the location has never been inspected
export interface IInspectionComplianceStatus {
  formId?: string
  reportDate?: string
  reporterName?: string
  daysSince?: number
  isOverdue: boolean
}

export interface IInspectionComplianceItem {
  locationId: string
  locationName: string
  curbAppeal: IInspectionComplianceStatus
  showroomInspection: IInspectionComplianceStatus
}

export interface IInspectionComplianceResponse {
  windows: IInspectionWindowItem[]
  items: IInspectionComplianceItem[]
}

export const InspectionFormTypeToLabel: Record<InspectionFormType, string> = {
  [FormType.CurbAppeal]: 'Curb Appeal Inspection',
  [FormType.ShowroomInspection]: 'Showroom Inspection'
}

export const MIN_INSPECTION_WINDOW_DAYS = 1
export const MAX_INSPECTION_WINDOW_DAYS = 999

export function isValidInspectionWindow(days: unknown): boolean {
  const value = typeof days === 'string' ? days.trim() : days
  if (value === '' || value === null || value === undefined) {
    return false
  }
  const num = Number(value)
  return Number.isInteger(num) && num >= MIN_INSPECTION_WINDOW_DAYS && num <= MAX_INSPECTION_WINDOW_DAYS
}
